module.exports = "<div id=\"{{id}}\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/src/app/label/label.component.html
// module id = ../../../../../src/app/label/label.component.html
// module chunks = 1